// @flow

import type { Interval } from '@zapier/common-utils';

export type InvoiceLineItem = {|
  amount: number,
  description?: string,
  id: string,
|};

export type InvoiceLineSubscription = {|
  amount: number,
  id: string,
  plan?: {
    interval: Interval,
    name: string,
  },
|};

export const trialExtensionReasons: {
  [string]: string,
} = {
  paths: 'paths',
  multistep: 'multistep',
  premium: 'premium',
  premiumLimit: 'premium-limit',
  zapLimit: 'live-zaps',
  taskLimit: 'tasks',
  emailSupport: 'email-support',
  unknown: 'unknown',
};

export type TrialExtensionReason = $Keys<typeof trialExtensionReasons>;
